import { createContext, useContext } from 'react'
import type { IClickToText } from 'entities/ClickToText'

export const ClickToTextDetailsModalContext = createContext<IClickToText | null>(null)

export const useClickToTextDetailsModalContext = () => {
  const context = useContext(ClickToTextDetailsModalContext)

  if (context === null) {
    throw new Error(
      'You have forgotten to wrap your root component with ClickToTextDetailsModalContext'
    )
  }

  return context
}
